import LogoZslinth from './assets/szenen_Schrift_Logo_233x45.png';
import type { CustomerVariables } from '@/@types/globals';

export function defineVariables(defaultVariables: CustomerVariables): CustomerVariables {
    const thisYear = new Date().getFullYear();
    defaultVariables.logo = { image: LogoZslinth, width: 1000, height: 193, alt: 'szenen-kultur.ch Logo' };
    defaultVariables.signupUrl = '';
    defaultVariables.loginFooterHtml = `
        <p class="tgk-paragraph-text">
        (c) 2009-${thisYear} szenen-kultur.ch. All rights reserved.<br>
        <a href="#">Datenschutz</a> |
        <a href="https://szenen-kultur.ch/impressum">Impressum</a>
        </p>
        `;
    defaultVariables.vuetifyThemeColors = {
        primary: '#d21871',
        primaryToggled: '#B80040',
        secondary: '#424242',
        anchor: '#E3004F',
        accent: '#82B1FF',
        action: '#E3004F',
        error: '#FF5252',
        attention: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
    };

    return defaultVariables;
}
